import {Children, ClassComponent, Vnode} from 'mithril';
import ValidationErrors from './ValidationErrors';
import {FieldValidationErrors} from '../models/JsonTypes';

interface FormGroupAttrs {
    label?: Children
    className?: string
    description?: Children
    validationErrors?: string[] | FieldValidationErrors
}

export default class FormGroup implements ClassComponent<FormGroupAttrs> {
    view(vnode: Vnode<FormGroupAttrs, this>) {
        let errors = vnode.attrs.validationErrors || [];

        // This check is to make using FormGroup outside of templates easier,
        // as we can simply pass the validation tree filtered to the key, and take care of the "errors" sub-object here
        if (typeof errors === 'object' && !Array.isArray(errors)) {
            errors = errors.errors || [];
        }

        return m('.Form-group.Formulaire-form-group', {
            className: (errors && errors.length ? 'in-error' : '') + (vnode.attrs.className ? ' ' + vnode.attrs.className : ''),
        }, [
            m('.Form-group-label', [
                vnode.attrs.label,
                vnode.attrs.description ? m('p', vnode.attrs.description) : null,
            ]),
            m('.Form-group-field', [
                vnode.children,
                m(ValidationErrors, {
                    errors: errors,
                }),
            ]),
        ]);
    }
}
